import { render } from "./App.vue?vue&type=template&id=4e1fe2b2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4e1fe2b2&lang=scss"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__